package com.partejar.app.core.di

import com.partejar.app.core.ui.theme.AppThemeViewModel
import com.partejar.app.feature.auth.presentation.AuthViewModel
import com.partejar.app.feature.account.presentation.AccountDeletionViewModel
import com.partejar.app.feature.home.presentation.HomeViewModel
import com.partejar.app.feature.splash.presentation.SplashViewModel
import com.partejar.app.feature.workspace.presentation.WorkspaceViewModel
import com.partejar.app.feature.gestantes.presentation.GestantesViewModel
import com.partejar.app.feature.gestantes.presentation.GestanteDetailViewModel
import com.partejar.app.feature.equipe.presentation.EquipeViewModel
import com.partejar.app.feature.equipe.data.EquipeDataSource
import com.partejar.app.feature.entitlements.presentation.EntitlementCoordinator
import com.partejar.app.feature.planos.presentation.PlanosViewModel
import com.partejar.app.feature.convite.presentation.ConviteAceiteViewModel
import com.partejar.app.feature.profile.presentation.ProfileViewModel
import com.partejar.app.feature.calendar.presentation.CalendarIntegrationViewModel
import com.partejar.app.feature.relacionamentos.presentation.RelacionamentoDetailViewModel
import com.partejar.app.feature.relacionamentos.presentation.RelacionamentosViewModel
import com.partejar.app.feature.relacionamentos.presentation.NovoRelacionamentoViewModel
import com.partejar.app.feature.modeloscontrato.presentation.ModelosContratoViewModel
import com.partejar.app.feature.contratos.presentation.ContratoViewModel
import com.partejar.app.feature.contratos.presentation.PublicContractSignatureViewModel
import com.partejar.app.feature.agenda.presentation.AgendaViewModel
import org.koin.dsl.module

val viewModelModule = module {
    single { AppThemeViewModel(get()) }
    factory { AuthViewModel(get(), get(), get()) }
    factory { AccountDeletionViewModel(get(), get(), get()) }
    factory { SplashViewModel(get(), get()) }
    factory { HomeViewModel(get()) }
    factory { WorkspaceViewModel(get(), get(), get()) }
    factory { GestantesViewModel(get()) }
    factory { GestanteDetailViewModel(get()) }
    factory { EquipeViewModel(get<EquipeDataSource>(), get<EntitlementCoordinator>()) }
    factory { PlanosViewModel(get()) }
    factory { ConviteAceiteViewModel(get(), get(), get()) }
    factory { ProfileViewModel(get(), get()) }
    factory { parameters -> CalendarIntegrationViewModel(parameters.get<com.partejar.app.feature.calendar.CalendarIntegration>(), get<com.partejar.app.feature.calendar.CalendarSyncPreferences>()) }
    factory { RelacionamentosViewModel(get()) }
    factory { RelacionamentoDetailViewModel(get<com.partejar.app.feature.relacionamentos.data.RelacionamentosDataSource>(), get<com.partejar.app.feature.contratos.data.ContratosDataSource>()) }
    factory { NovoRelacionamentoViewModel(get(), get()) }
    factory { ModelosContratoViewModel(get()) }
    factory { ContratoViewModel(get(), get()) }
    factory { PublicContractSignatureViewModel(get()) }
    factory { AgendaViewModel(get()) }
}
